import React, { useState } from "react";
import i18next from "i18next";
import { withTranslation, useTranslation } from "react-i18next";

const LangSelect = (props) => {
  const lng = localStorage.getItem("language");

  const onChange = ({ target }) => {
    const { value } = target;
    localStorage.setItem("language", value);
    i18next.changeLanguage(value);
  };

  return (
    <div className="lang-select">
      <div className="selected">Language</div>
      <div className="select-box">
        <div className="options-container">
          <div className="select-list">
            <label htmlFor="kr" className="select-option">
              <span>
                <i className="flags kr"></i> 한국어
              </span>
              <input
                onChange={onChange}
                type="radio"
                value={"kr"}
                id="kr"
                name="lng"
                checked={lng === "kr" ? true : false}
              />
            </label>
          </div>
          <div className="select-list">
            <label htmlFor="en" className="select-option">
              <span>
                <i className="flags en"></i> English
              </span>
              <input
                onChange={onChange}
                type="radio"
                value={"en"}
                id="en"
                name="lng"
                checked={lng === "en" ? true : false}
              />
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(LangSelect);
